module.exports = __webpack_public_path__ + "static/media/mysafestay.1946ebff.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/mysafestay.PNG
// module id = 94
// module chunks = 0